<template>
  <b-modal
    size="md"
    :title="$t('notification.alert.eachEventNeedAction')"
    hide-header-close
    id="urgent-video-modal"
    centered
  >
    <div class="embed-responsive">
      <iframe
        class="embed-responsive-item"
        src="https://www.youtube.com/embed/Twhwm4DHyDU?si=OH_n9n0Q0gttVdKa"
        allowfullscreen
      ></iframe>
    </div>

    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
          <McButton
            variant="outline-primary"
            @click="cancel()"
            class="me-2"
            :text="$t('global.action.close')"
          />
          <McButton
            variant="primary"
            @click="openModal"
            :text="$t('notification.alert.activateNow')"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import McButton from '@/components/McButton'
import { mapActions } from 'vuex'
import { store as storeAddonSpecific } from '@/services/rest-api/lib/addon-specific/addon-specific'
export default {
  components: {
    McButton,
  },
  methods: {
    ...mapActions('modal', ['openSuccessModal']),
    async openModal() {
      this.$bvModal.show('urgent-active')
      this.$bvModal.hide('urgent-video-modal')
    },
  },
}
</script>
<style lang="scss" scoped>
.embed-responsive {
  iframe {
    width: 100%;
    height: 250px;
  }
}
</style>
